import { sanitizePageViewPath } from "./pageViewPath";

const GTM_PAGE_VIEW_EVENT = "rh_consent_page_view";

type GtmPageContextWindow = {
  dataLayer?: Array<Record<string, unknown> | unknown[]>;
  location: {
    origin: string;
  };
};

export const queueGtmContainerBootstrap = (
  targetWindow: Pick<GtmPageContextWindow, "dataLayer">,
  updateConsent: () => void,
): void => {
  targetWindow.dataLayer = targetWindow.dataLayer || [];
  targetWindow.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
  updateConsent();
};

let lastPushedRouteKey: string | null = null;

export const pushSanitizedGtmPageView = (
  targetWindow: GtmPageContextWindow,
  pagePath: string,
): boolean => {
  const sanitizedPagePath = sanitizePageViewPath(pagePath);

  if (lastPushedRouteKey === sanitizedPagePath) {
    return false;
  }

  targetWindow.dataLayer = targetWindow.dataLayer || [];
  targetWindow.dataLayer.push({
    event: GTM_PAGE_VIEW_EVENT,
    page_location: `${targetWindow.location.origin}${sanitizedPagePath}`,
    page_path: sanitizedPagePath,
  });
  lastPushedRouteKey = sanitizedPagePath;

  return true;
};

export const resetSanitizedGtmPageViewDedupeForTests = (): void => {
  lastPushedRouteKey = null;
};
